import * as R from 'ramda';
const ENDPOINT_UPLOAD = 'https://api.imgur.com/3/upload'; //これはCORSが発生した。imageのほうならいけた。

const ENDPOINT_IMAGE = 'https://api.imgur.com/3/image';
const CLIENT_ID = '8be66e69642ff16';
const CLIENT_SECRET = '802dc31909019a78ec544793083be7772ce6e8d7';

//CORSを突破できそうにないので断念
export const postToImgur = async (base64: string) => {
	const response = await fetch(ENDPOINT_IMAGE, {
		method: 'POST',
		mode: 'cors',
		headers: new Headers({
			'Content-Type': 'application/json',
			Authorization: 'Client-ID ' + CLIENT_ID,
		}),
		/*
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Client-ID ' + CLIENT_ID,
		},*/
		body: JSON.stringify(createBody(base64)),
		cache: 'no-cache',
	}).catch((e) => {
		console.log({ imgur_reques_failed: e });
		return undefined;
	});

	if (!response) {
		return;
	}

	return await getUrlFromResponse(response);
};

const getUrlFromResponse = async (
	response: Response,
): Promise<string | undefined> => {
	if (!response.ok) {
		return;
	}
	// HTTP ステータスが 200-299 の場合
	const parsed = await response.json().catch((e) => {
		console.log({ imgur_resparse_failed: e });
		return undefined;
	});
	const url: string | undefined = R.path<string>(['data', 'link'])(parsed);
	return url;
};

const createBody = (base64: string) => ({
	image: base64.split(',')[1], //頭についてる「data:image/png;base64,」を除去
	type: 'base64',
});
/*
	// (1)ファイルをバイナリ化
	let bin = window.atob(base64.replace(/^.*,/, ''));
	console.log({ bin: bin });
	// (2)バイナリデータに変換する
	let buffer = new Uint8Array(bin.length);
	for (let i = 0; i < bin.length; i++) {
		buffer[i] = bin.charCodeAt(i);
	}
	// (3)Fileオブジェクトを生成
	let image_file = new File([buffer.buffer], 'canvas', { type: 'image/png' });

	let data = new FormData();
	let content = {
		method: 'POST',
		headers: {
			Authorization: 'Client-ID ' + CLIENT_ID,
			Accept: 'application/json',
		},
		body: data,
		mimeType: 'multipart/form-data',
	};
	data.append('image', image_file);
	data.append('type', 'base64');
	console.log({ post: content });
	const r = await fetch(ENDPOINT_UPLOAD, content);
	console.log({ apires: r });








	let data = new FormData();
	let content = {
		method: 'POST',
		headers: {
			Authorization: 'Client-ID ' + CLIENT_ID,
			Accept: 'application/json',
		},
		body: data,
		mimeType: 'multipart/form-data',
	};
	data.append('image', base64.split(',')[1]);
	data.append('type', 'base64');
	console.log({ post: content });
	const r = await fetch(ENDPOINT_UPLOAD, content);
	console.log({ apires: r });

	var data = new FormData();
	data.append('image', base64.split(',')[1]);
	data.append('type', 'base64');
	var xhr = new XMLHttpRequest();
	xhr.open('POST', 'https://api.imgur.com/3/upload', true);
	xhr.setRequestHeader('Authorization', 'Client-ID ' + CLIENT_ID);
	xhr.send(data);
	//readyStateが変更されるたびに実行される関数を格納する変数(オプション)がonreadystatechange
	xhr.onreadystatechange = function () {
		if (xhr.readyState === 4 && xhr.status === 200) {
			const result = JSON.parse(xhr.responseText); //戻ってきたjson(String型)を辞書型配列に変換
			console.log({ apires_success: result });
		} else {
			const result = JSON.parse(xhr.responseText);
			console.log({ apires_fail: result });
		}
	};
	

	const r = await fetch(ENDPOINT_UPLOAD, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: 'Client-ID ' + CLIENT_ID,
		},
		body: JSON.stringify(createBody(base64)),
		cache: 'no-cache',
	});
	
//console.log({ apires: r });
*/
